import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: RouteComponent
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { user } = Route.useRouteContext()

  useEffect(() => {
    if (user) {
      navigate({ to: '/dashboard' })
    } else {
      navigate({ to: '/sign-in' })
    }
  }, [navigate, user])

  return <></>
}
